// extracted by mini-css-extract-plugin
export default {"paymentSection":"L1-z","disabled":"M1-z"};